import axios from 'axios';

const state = {
  list: [],
  fullCount: 0,
  sort: {},
  page: {
    pageSize: 10,
    page: 1,
  },
  filter: '',
};

const getters = {
  getUserById: st => id => st.list.find(u => u._id === id),
};

const actions = {
  async getUsers({ commit, state: st }) {
    let url = `${process.env.VUE_APP_API_USERS_ROOT}/users`;
    url += `?paging=true&page=${st.page.page}&pageSize=${st.page.pageSize}`;

    if (st.sort.field) {
      url += `&sorting=true&sortField=${st.sort.field}&sortDirection=${st.sort.direction}`;
    }

    if (st.filter && st.filter !== '') {
      url += `&filtering=true&filter=${st.filter}`;
    }
    const response = await axios.get(url);

    commit('setUsers', response.data.users);
    commit('setCount', response.data.count);
  },
  sortUsers({ commit, state: st, dispatch }, field) {
    if (st.sort && st.sort.field === field) {
      if (st.sort.direction === 'ASC') {
        commit('setSortDirection', 'DESC');
      } else if (st.sort.direction === 'DESC') {
        commit('setSortDirection', 'ASC');
      }
    } else {
      commit('setSortDirection', 'ASC');
      commit('setSortField', field);
    }

    dispatch('getUsers');
  },
  async setPage({ commit, dispatch }, page) {
    commit('setPage', page);
    await dispatch('getUsers');
  },
  setFilter({ commit, dispatch }, filter) {
    commit('setFilter', filter);
    dispatch('getUsers');
  },
  async getUser({ commit }, id) {
    const response = await axios.get(`${process.env.VUE_APP_API_USERS_ROOT}/users/${id}`);

    commit('addUser', response.data);
  },
};

const mutations = {
  setUsers(st, payload) {
    st.list = payload;
  },
  setCount(st, payload) {
    st.fullCount = payload;
  },
  setSortDirection(st, payload) {
    st.sort.direction = payload;
  },
  setSortField(st, payload) {
    st.sort.field = payload;
  },
  setPage(st, page) {
    st.page.page = page;
  },
  setFilter(st, filter) {
    st.filter = filter;
  },
  addUser(st, user) {
    st.list.push(user);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
